<template>
	<div v-if="isFinish" class="w-[50vw] h-[80vh] bg-white px-[40px] pt-[4%] box-border top-[50%] left-[50%] absolute "
		style="transform: translate(-50%,-50%);">
		<div class="text-[20px] font-bold text-[#1B2128] mb-[26px]">
			{{paperInfo.chapter_name ||''}}
		</div>
		<div class="leading-[30px] text-[16px] text-[#686C73] mb-[60px]">
			<div >
				{{langInfo.study_test_name}}: {{paperInfo.title||''}}
			</div>
			<div v-if="type_part==1" class="mt-[10px]">
				<div class="mb-[10px]" v-for="(item,index) in question_paper_part" :key="index">
					<label v-if="item.question_type=='single'">{{langInfo.study_paper_result_select}}：</label>
					<label v-else-if="item.question_type=='case'">{{langInfo['Case Analysis Question']}}：</label>
					{{item.name}}<br />
					{{langInfo.study_test_pass}}: {{item.passing_score||''}}
					{{langInfo.study_paper_result_part||''}}<br />
					{{langInfo.study_test_total}}: {{item.total_score||''}}
					{{langInfo.study_paper_result_part||''}}<br />
				</div>
			</div>
			<div v-else-if="type_part==0">
				{{langInfo.study_test_pass}}: {{paperInfo.passing_mark||''}}
				{{langInfo.study_paper_result_part||''}}<br />
				{{langInfo.study_test_total}}: {{paperInfo.total_score||''}}
				{{langInfo.study_paper_result_part||''}}<br />
			</div>
			<div class="">
				{{langInfo.study_test_duration}}: {{paperInfo.exam_duration||''}} {{langInfo.study_test_remark1_1||''}}
			</div>

		</div>
		<div class="text-[16px] text-[#686C73] mb-[10px]">
			{{langInfo.study_test_title}}：
		</div>
		<div class="text-[12px] text-[#FF0000] leading-[30px] mb-[20px]">
			1、{{langInfo.study_test_remark1}}{{paperInfo.exam_duration||''}}{{langInfo.study_test_remark1_1||''}} <br />
			2、{{langInfo.study_test_remark2||''}}<br />

			3、{{langInfo.study_test_remark3||''}}
		</div>
		<div @click="startExam()" v-if="isFinish"
			class="w-[200px] h-[40px] leading-[40px] cursor-pointer mx-auto rounded-[6px] text-center text-white text-[16px] bg-[#68C340]">
			{{langInfo.study_test_start}}
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				subjectName: '',
				id: '',
				testMethod: '',
				order_item_id: "",
				type_part: 0, //1有部分的题 0是原来的
				paperInfo: {

				},

				question_paper_part: [],
				langInfo: {},
				isFinish: false
			}
		},
		mounted() {
			this.subjectName = this.$route.query.subjectName
			this.id = this.$route.query.id
			this.testMethod = this.$route.query.testMethod
			this.order_item_id = this.$route.query.order_item_id

			this.type_part = this.$route.query.type_part

			this.isFinish = false
			this.getPaperInfo()
			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}

		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			getPaperInfo() {
				this.$api.PaperInfo({
					id: this.id
				}).then((res) => {
					console.log(res);
					this.paperInfo = res.data

					this.question_paper_part = res.data.question_paper_part || []
					this.isFinish = true

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 开始考试
			startExam() {
				if (this.type_part == 1) {
					this.$router.push({
						path: 'multipleQuestions',
						query: {
							order_item_id: this.order_item_id,
							id: this.id,
							identification: this.paperInfo.identification
						}
					})
				} else {
					this.$router.push({
						path: 'examQuestions',
						query: {
							order_item_id: this.order_item_id,
							id: this.id,
							identification: this.paperInfo.identification
						}
					})
				}
			}
		}
	}
</script>

<style>
</style>